var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeveloperBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 7.5V5.83333H16.6667V4.16667C16.6667 3.25 15.9167 2.5 15 2.5H3.33335C2.41669 2.5 1.66669 3.25 1.66669 4.16667V15.8333C1.66669 16.75 2.41669 17.5 3.33335 17.5H15C15.9167 17.5 16.6667 16.75 16.6667 15.8333V14.1667H18.3334V12.5H16.6667V10.8333H18.3334V9.16667H16.6667V7.5H18.3334ZM15 15.8333H3.33335V4.16667H15V15.8333ZM5.00002 10.8333H9.16669V14.1667H5.00002V10.8333ZM10 5.83333H13.3334V8.33333H10V5.83333ZM5.00002 5.83333H9.16669V10H5.00002V5.83333ZM10 9.16667H13.3334V14.1667H10V9.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperBoard);
export default __webpack_public_path__ + "static/media/developer-board.fd00000b5ad121bae6f73e070f0913bf.svg";
export { ForwardRef as ReactComponent };